import ChannelBucketSelect from './ChannelBucketSelect';

export default ChannelBucketSelect;
